import { OnboardingSetupStage, OnboardingTrainingStatus } from "~/gql/graphqlBase.generated";

export interface TrainingCompleteInput {
	trainingStatus: OnboardingTrainingStatus;
}

export interface StillOnboardingInput {
	onboardingSetup: OnboardingSetupStage;
	trainingComplete: boolean;
}

const isTrainingComplete = ({ trainingStatus }: TrainingCompleteInput): boolean =>
	trainingStatus === OnboardingTrainingStatus.Complete;

const isStillOnboarding = ({ onboardingSetup, trainingComplete }: StillOnboardingInput): boolean =>
	onboardingSetup !== OnboardingSetupStage.Unknown &&
	!(onboardingSetup === OnboardingSetupStage.Live && trainingComplete);

const onboardingTraining = {
	isStillOnboarding,
	isTrainingComplete
};

export default onboardingTraining;
